import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import { Rive, RuntimeLoader } from "@rive-app/canvas-lite";

// // @todo fix wasm loading
// import riveWASMResource from '@rive-app/canvas-lite/rive.wasm';
// RuntimeLoader.setWasmUrl(riveWASMResource);

gsap.registerPlugin(ScrollTrigger);

// const STATE_MACHINES_NAME = "eup240k";

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-section-header]');

  triggers.forEach((trigger) => {
    // console.log(trigger);

    gsap.to(trigger, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate: (self) => {
          trigger.style.setProperty('--_progress', -0.5 + self.progress);
        },
      },
    });

    // let normalizedY = 0;
    // let volumeInput;

    // document.addEventListener("mousemove", function (event) {
    //   normalizedY = 100 - (event.clientY / window.innerHeight) * 100;
    //   volumeInput.value = normalizedY;
    // });

    // const r = new Rive({
    //   src: "soundwave.riv",
    //   canvas: document.getElementById("canvas"),
    //   autoplay: true,
    //   stateMachines: STATE_MACHINES_NAME,
    //   onLoad: () => {
    //     r.resizeDrawingSurfaceToCanvas();

    //     volumeInput = r.stateMachineInputs(STATE_MACHINES_NAME)[0];
    //   },
    // });
  });
};

export default function SectionHeader() {
  return {
    init: () => {
      setup();
    },
  };
}
